<template>
  <div id="question-pagination">
    <div class="paging">
      <div class="paging-item prev" :class="[isPrevActive ? 'prev-active' : '']" @click="prevPage"></div>
      <div class="paging-item" v-for="item in pageCount" :key="item.id" :class="{active: item.isActive}" @click="selectPage(item.id)">{{ item.text }}</div>
      <div class="paging-item next" :class="[isNextActive ? 'next-active' : '']" @click="nextPage"></div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  name: 'questionPagination',
  props: {
    label: Number,
    typeId: Number
  },
  data () {
    return {
      pageCount: [
        {id: 0, text: 1, isActive: true}
      ],
      selectedCount: 0
    }
  },
  computed: {
    ...mapGetters([
      'getQuestionPage',
      'getPageCount',
      'getPageSize'
    ]),
    isPrevActive () {
      return this.selectedCount !== 0
    },
    isNextActive () {
      return this.selectedCount !== this.getPageCount - 1
    }
  },
  methods: {
    ...mapActions([
      'action_getHotQuestionPage',
      'action_getClassifyQuestionPage',
      'action_getUserQuestionPage',
      'setQuestionPage',
      'setAllQuestionCount'
    ]),
    currentChange () {
      let params = null
      if (this.label === 0) {
        if (this.typeId === -1) {
          params = {
            currentPage: this.selectedCount,
            pageSize: this.getPageSize
          }
          this.action_getHotQuestionPage(params).then(res => {
            if (res.erpCode === '000') {
              this.setQuestionPage(res.erpData.pageItem)
              this.setAllQuestionCount(res.erpData.totalCount)
            } else {
              this.showMessage(res.erpMsg || '获取问题列表出错')
            }
          })
        } else {
          params = {
            type: this.typeId,
            currentPage: this.selectedCount,
            pageSize: this.getPageSize
          }
          this.action_getClassifyQuestionPage(params).then(res => {
            if (res.erpCode === '000') {
              this.setQuestionPage(res.erpData.pageItem)
              this.setAllQuestionCount(res.erpData.totalCount)
            } else {
              this.showMessage(res.erpMsg || '获取问题列表出错')
            }
          })
        }
      } else {
        params = {
          currentPage: this.selectedCount,
          pageSize: this.getPageSize
        }
        this.action_getUserQuestionPage(params).then(res => {
          if (res.erpCode === '000') {
            this.setQuestionPage(res.erpData.pageItem)
            this.setAllQuestionCount(res.erpData.totalCount)
          } else {
            this.showMessage(res.erpMsg || '获取问题列表出错')
          }
        })
      }
      this.pageCount.forEach(item => {
        if (item.id === this.selectedCount) {
          item.isActive = true
        } else {
          item.isActive = false
        }
      })
    },
    selectPage (id) {
      this.selectedCount = id
      this.getPage()
    },
    prevPage () {
      if (this.selectedCount) {
        this.selectedCount -= 1
        this.getPage()
      }
    },
    nextPage () {
      if (this.selectedCount < this.getPageCount - 1) {
        this.selectedCount += 1
        this.getPage()
      }
    },
    resetPageCount () {
      this.selectedCount = 0
      this.pageCount = []
      for (let i = 0; i < this.getPageCount; i++) {
        if (i === 0) {
          this.pageCount.push({
            id: i,
            text: i + 1,
            isActive: true
          })
        } else {
          this.pageCount.push({
            id: i,
            text: i + 1,
            isActive: false
          })
        }
      }
    }
  },
  watch: {
    label (val) {
      this.resetPageCount()
    },
    typeId (val) {
      this.resetPageCount()
    },
    getPageCount (val) {
      this.resetPageCount()
    }
  }
}
</script>

<style scoped>
  #question-pagination {
    position: absolute;
    left: 50%;
    bottom: 6px;
    text-align: center;
    transform: translate(-50%, 0);
  }
  .paging {
    box-sizing: border-box;
    display: inline-block;
    height: 29px;
    border: 1px solid #4A90E2;
    border-radius: 1px;
    margin-top: 22px;
    font-size: 0;
    background: #FFFFFF;
  }
  .paging-item {
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
    width: 27px;
    height: 27px;
    margin-right: 1px;
    box-shadow: 1px 0 0 0 #C9D2DC;
    font-size: 13px;
    color: #333333;
    line-height: 27px;
    text-align: center;
    letter-spacing: -0.31px;
    cursor: pointer;
  }
  .paging-item:nth-last-child(1) {
    margin: 0;
    box-shadow: 0 0 0 0 #C9D2DC;
  }
  .prev {
    cursor: not-allowed;
    background: url("../../icons/left-arrow-gray.svg") no-repeat center center;
  }
  .prev-active {
    cursor: pointer;
    background: url("../../icons/left-arrow-blue.svg") no-repeat center center;
  }
  .next {
    cursor: not-allowed;
    background: url("../../icons/right-arrow-gray.svg") no-repeat center center;
  }
  .next-active {
    cursor: pointer;
    background: url("../../icons/right-arrow-blue.svg") no-repeat center center;
  }
  .active {
    color: #fff;
    background: #4A90E2;
    box-shadow: 0 0 0 1px #4A90E2;
  }
</style>



// WEBPACK FOOTER //
// src/components/question-pagination/question-pagination.vue